import SettingsPage from './SettingsPage';

export const components = {
  SettingsPage,
};
